<template>
	<div>
		<van-nav-bar title="盘库结果" left-text="返回" left-arrow @click-left="onClickLeft" fixed />
		<div class="psiConfirmCont">
			<div style="display: flex;">
				<table style="width: 100%;margin-bottom: 3px;">
					<tr style="height:40px;">
						<td style="width: 20%;text-align: center;">扫码总数:</td>
						<td style="width: 30%;">{{totalNum}}</td>
						<td style="width: 20%;">盘平:</td>
						<td style="width: 30%;color:#70B603;">{{normalNum}}</td>
					</tr>
					<tr style="height:40px;">
						<td style="width: 20%;text-align: center;">盘盈:</td>
						<td style="width: 30%;color:#D9001B;">{{profitNum}}</td>
						<td style="width: 20%;">盘亏:</td>
						<td style="width: 30%;color:#FFCC00;">{{lossNum}}</td>
					</tr>
				</table>
			</div>
			<div class="psiDetailCont">
				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<van-list v-model="loading" :finished="finished" @load="onLoad" :finished-text="overText">
						<div v-for="item in list" class="card" :key="item.uuid">
							<template>
								<table class="layout" style="width: 100%;">
									<tr style="width: 100%;">
										<td style="padding-left: 20px;width: 70%;">{{item.barcode}}</td>
										<td style="text-align: center;width: 30%;color:#D9001B;" v-if="item.typename=='盘盈'">{{item.typename}}</td>
										<td style="text-align: center;width: 30%;color:#70B603;" v-if="item.typename=='盘平'">{{item.typename}}</td>
										<td style="text-align: center;width: 30%;color:#FFCC00;" v-if="item.typename=='盘亏'">{{item.typename}}</td>
									</tr>
								</table>
							</template>
						</div>
					</van-list>
				</van-pull-refresh>
			</div>
			<div class="recordBox">
				<van-button type="info" size="large" v-if="isVisible" @click="continueStockTaking()">重新盘库</van-button>
			</div>
			
		</div>
	</div>
</template>

<script>
	import {NavBar, Field, Button, List, PullRefresh,Toast} from 'vant';
    import barcodeService from "../../service/barcodeService";
    import {formatDictionary} from "../../utils/dictionary";
	import userInfo from '../../store/userInfo';
	export default {
		data() {
			return {
				totalNum:0,
				normalNum:0,
				profitNum: 0,
				lossNum: 0,
				stockTakingId: '',
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				overText: "没有更多了",
				creatorId: "",
				isVisible: false
			};
		},
		mounted: function () {
			this.stockTakingId = this.$route.query.stockTakingId;
			this.creatorId = this.$route.query.creatorId;
			this.isVisible = this.creatorId == userInfo.state.userId;
			this.getStockTakingResult();
		},
		components: {
			[NavBar.name]: NavBar,
			[Field.name]: Field,
			[Button.name]: Button,
            [List.name]: List,
            [PullRefresh.name]: PullRefresh
		},
		methods: {
			onClickLeft() {
			    this.$router.push('/rad/stocktaking')
			},
			async getStockTakingResult(){
				let resp = await barcodeService.getStockTakingResult(this.stockTakingId);
				if (resp.data.Status === "1"){
					this.normalNum = resp.data.Data.normalNum;
					this.profitNum = resp.data.Data.profitNum;
					this.lossNum = resp.data.Data.lossNum;
					this.totalNum = this.normalNum + this.profitNum;
				}
			},
			async onLoad() {
				this.pageIndex++;
				let resp = await barcodeService.getStockTakingDetailList(this.pageIndex, this.stockTakingId, "simple");
				formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
        		this.loading = false;
        		this.refreshing = false;
				this.list = [...this.list, ...resp.data.Data.data];
				this.finished = resp.data.Data.total <= this.list.length;
				if(resp.data.Data.total == 0){
					this.overText = "盘库完成，无盘盈和盘亏！";
				}else{
					this.overText = "没有更多了";
				}
			},
			onRefresh() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			async continueStockTaking(){
				let resp = await barcodeService.updateStockTakingStatus(this.stockTakingId);
				if (resp.data.Status === "1"){
					this.$router.push({path:"stocktakingDetail",query:{stockTakingId:this.stockTakingId}});
				}
			}
		}
	}
</script>

<style scoped>
	.psiConfirmCont{
		width:100%;
		margin:0 auto;
		margin-top:120px;
		overflow: hidden;
	
	}
	.btnBox {
		
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
	.psiDetailCont{
		width:100%;
		margin:0 auto;
		margin-top:20px;
	}
</style>
